export default "__VITE_ASSET__CWPaZwM2__"